import React from "react";

interface Props {
    handleToggle: () => void;
}

const CSS_CLASS_NAME = "c-mobile-secondary-nav__handle";

const MobileBookviewSearchHandle = ({ handleToggle }: Props) => {
    return (
        <div
            className={CSS_CLASS_NAME}
            role="button"
            onPointerUp={handleToggle}>
            <div className={`${CSS_CLASS_NAME}__button`} />
        </div>
    );
};

export default MobileBookviewSearchHandle;
